import { render, staticRenderFns } from "./ConversationsCategoryTabs.vue?vue&type=template&id=7c92e1bf&scoped=true&"
import script from "./conversations-category-tabs.ts?vue&type=script&lang=ts&"
export * from "./conversations-category-tabs.ts?vue&type=script&lang=ts&"
import style0 from "./ConversationsCategoryTabs.vue?vue&type=style&index=0&id=7c92e1bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c92e1bf",
  null
  
)

export default component.exports